import { render, staticRenderFns } from "./CommonTag.vue?vue&type=template&id=7a364ba2&scoped=true&"
import script from "./CommonTag.vue?vue&type=script&lang=js&"
export * from "./CommonTag.vue?vue&type=script&lang=js&"
import style0 from "./CommonTag.vue?vue&type=style&index=0&id=7a364ba2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a364ba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/.jenkins/workspace/platform_dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a364ba2')) {
      api.createRecord('7a364ba2', component.options)
    } else {
      api.reload('7a364ba2', component.options)
    }
    module.hot.accept("./CommonTag.vue?vue&type=template&id=7a364ba2&scoped=true&", function () {
      api.rerender('7a364ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CommonTag.vue"
export default component.exports